window.Parcela = Backbone.Model.extend({

});

window.Parcelas = Backbone.Collection.extend({
    model: Parcela
});